import Chip from '@components/chip/Chip';
import deriveDarkColor from '@helpers/color';
import { Tag } from 'types/lead-management';

// Tag colour as the chip background, with a darker shade of it for the text
export const getTagChipStyle = (tag: Tag) => ({
  backgroundColor: tag.color || '#FFFFFF',
  color: deriveDarkColor(tag.color || '#FFFFFF')
});

/** Tag chip without a remove icon, for places that only show tags. */
const ReadOnlyTagChip = ({ tag }: { tag: Tag }) => (
  <Chip
    label={tag.name}
    isCloseIconRequired={false}
    className="!rounded-xl px-2 py-1 text-sm"
    style={getTagChipStyle(tag)}
    labelStyle="max-w-28 !text-sm !font-normal"
  />
);

export default ReadOnlyTagChip;
